
import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from "@angular/cdk/clipboard";
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';


@Component({
    selector: 'app-duplicate-file-upload-dialog',
    templateUrl: './duplicate-file-upload-dialog.component.html',
    styleUrls: ['./duplicate-file-upload-dialog.component.scss'],
    imports: [MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatTooltip, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow]
})
export class DuplicateFileUploadDialogComponent implements OnInit {
  private clipboard = inject(Clipboard);
  dialogRef = inject<MatDialogRef<DuplicateFileUploadDialogComponent>>(MatDialogRef);
  duplicateFiles = inject(MAT_DIALOG_DATA);

  public dataSource: string[] = [];
  displayedColumns: string[] = ["Path and filename"];


  ngOnInit(): void {
    this.dataSource = [...this.duplicateFiles];
  }

  onCloseClick():void{
    this.dialogRef.close();
  }

  copyToClipBoard():void{
    this.clipboard.copy(this.duplicateFiles.join(','));
  }
}
